const FirstHero = () => {
  return (
    <div className="container-fluid text-center">
      <div className="row">
        <div className="col bgimage">
          <div className="hero-text">
            <h1>BANGKOK HILL</h1>
            <h2>ORIGINAL THAI CUISINE</h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirstHero;
